import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import i18n from './i18n';

const setLangFont = () => {
  if (i18n.language === 'mr') {
    document.documentElement.lang = 'mr'; // HTML lang attribute
    document.body.style.fontFamily = "'Khand', sans-serif";
  } else {
    document.documentElement.lang = 'en';
    document.body.style.fontFamily = ''; // default font for English
  }
};

// Set font on initial load
setLangFont();

// Optional: Listen for language change dynamically
i18n.on('languageChanged', () => {
  setLangFont();
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
